import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activate: [],
    loading: false,
    error: null,
}

const ActivateSlice = createSlice({
    name: "activate",
    initialState,
    reducers: {
        fetchActivateSucess: (state, action) => {
            state.loading = false
            state.activate = action.payload;
        },
        fetchActivateFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchActivateSucess,
    fetchActivateFailure,
} = ActivateSlice.actions;

export default ActivateSlice.reducer;